import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Layout from "./components/layout/Layout";
import LandingPage from "./pages/LandingPage";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import Dashboard from "./pages/agent/Dashboard";
import QuotesList from "./pages/agent/QuotesList";
import QuoteBuilder from "./pages/agent/QuoteBuilder";
import QuoteDetail from "./pages/agent/QuoteDetail";
import Clients from "./pages/agent/Clients";
import Settings from "./pages/agent/Settings";
import ClientQuotePage from "./pages/client/ClientQuotePage";
import Pricing from "./pages/Pricing";
import SubscriptionGate from "./components/ui/SubscriptionGate";

function ProtectedRoute({ children }) {
  const { agent } = useSelector((state) => state.auth);
  if (!agent) return <Navigate to="/login" replace />;
  return children;
}

function PublicOrDashboard() {
  const { agent } = useSelector((state) => state.auth);
  if (agent) return <Navigate to="/dashboard" replace />;
  return <LandingPage />;
}

function App() {
  return (
    <Routes>
      {/* Landing page: public visitors see sales page, logged-in agents go to dashboard */}
      <Route path="/" element={<PublicOrDashboard />} />

      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/q/:shareToken" element={<ClientQuotePage />} />
      <Route path="/pricing" element={<Pricing />} />

      {/* Protected agent routes */}
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="quotes" element={<SubscriptionGate><QuotesList /></SubscriptionGate>} />
        <Route path="quotes/new" element={<SubscriptionGate><QuoteBuilder /></SubscriptionGate>} />
        <Route path="quotes/:id" element={<SubscriptionGate><QuoteDetail /></SubscriptionGate>} />
        <Route path="quotes/:id/edit" element={<SubscriptionGate><QuoteBuilder /></SubscriptionGate>} />
        <Route path="clients" element={<Clients />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
